import { clsx } from 'clsx';
import { FC } from 'react';

interface Props {
  type?: 'text' | 'fill';
  /** Width of the element in percent or with a specific CSS unit */
  size?: number | string;
}

export const Skeleton: FC<Props> = ({ type = 'text', size }) => (
  <span
    className={clsx('animate-pulse bg-whi-200', {
      ['vertical-align-text-top relative inline-block h-[1em] rounded-xs']: type === 'text',
      ['absolute top-0 left-0 block h-full w-full']: type === 'fill',
    })}
    aria-hidden="true"
    style={{ width: typeof size === 'number' ? `${size}%` : size }}
  />
);
